
export default function useDownloadCsv({ list, th, fileName }) {
  saveData2File(jsonDataToStr(list, th), fileName + '.csv')
  
  // [{ a: 1 }] => a, 1
  function jsonDataToStr(list, th) {
    // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
    let res = th
    // 增加\t为了不让表格显示科学计数法或者其他格式
    for(let i = 0; i < list.length; i++) {
      for(let item in list[i]){
        res += `${list[i][item] + '\t'},`
      }
      res += '\n'
    }
    return res
  }
  
  function saveData2File(data, fileName) {
    // 获取浏览器信息
    const bw = getBrowser()
    if (!bw['edge'] || !bw['ie']) {
      const link = document.createElement('a')
      const uri = getDownloadUri(data)
      link.href = uri
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else if (bw['ie'] >= 10 || bw['edge'] === 'edge') {
      // 为了使文件以utf-8的编码模式，同时也是解决中文乱码的问题
      const _utf = '\uFEFF'
      const blob = new Blob([_utf + data], {
        // 自己需要的数据格式
        type: 'text/json'
      })
      const navg: any = window.navigator
      navg.msSaveBlob(blob, fileName)
    }
  }
  
  function getDownloadUri(data) {
    // 为了使文件以utf-8的编码模式，同时也是解决中文乱码的问题
    const _utf = '\uFEFF'
    const createObjUrl: any = window.URL?.createObjectURL
    if (window.Blob && createObjUrl) {
      const blob = new Blob([_utf + data], {
        // 写自己需要的数据格式
        type: 'text/json'
      })
      return URL.createObjectURL(blob)
    } else {
      const mimeType = 'attachment/csv'
      const charset = ';charset=utf-8,'
      return 'data:' + mimeType + charset + _utf + encodeURIComponent(data)
    }
  }
  
  function getBrowser() {
    const sys: any = {};
    const ua: any = navigator.userAgent.toLowerCase()
    if (ua.indexOf('edge') !== -1) {
      sys.edge = 'edge'
    } else if (ua.match(/rv:([\d.]+)\) like gecko/)) {
      sys.ie = ua.match(/rv:([\d.]+)\) like gecko/)[1]
    } else if (ua.match(/msie ([\d.]+)/)) {
      sys.ie = ua.match(/msie ([\d.]+)/)[1]
    } else if (ua.match(/firefox\/([\d.]+)/)) {
      sys.firefox = ua.match(/firefox\/([\d.]+)/)[1]
    } else if (ua.match(/chrome\/([\d.]+)/)) {
      sys.chrome = ua.match(/chrome\/([\d.]+)/)[1]
    } else if (ua.match(/opera.([\d.]+)/)) {
      sys.opera = ua.match(/opera.([\d.]+)/)[1]
    } else if (ua.match(/version\/([\d.]+).*safari/)) {
      sys.safari = ua.match(/version\/([\d.]+).*safari/)[1]
    }
    return sys
  }
}
